{
	"trailingStop": {
		"price": "Trailing,$",
		"percent": "Trailing,%",
		"trailPrice": "Trail price",
		"trailPercent": "Trail percent"
	}
}
